var _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _g, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 72,
    width: 224,
    height: 300,
    rx: 4,
    fill: "#C8C2B4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 52,
    width: 224,
    height: 300,
    rx: 4,
    fill: "#FDFCF9",
    stroke: "#1B2B47",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 52 L360 112 Q360 52 300 52 Z",
    fill: "#1B2B47",
    opacity: 0.92
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360 52 Q360 112 300 112 L360 112 Z",
    fill: "#1B2B47",
    opacity: 0.92
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 82,
    width: 110,
    height: 7,
    rx: 3.5,
    fill: "#1B2B47"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 96,
    width: 56,
    height: 1.5,
    rx: 0.75,
    fill: "#1B2B47",
    opacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 106,
    width: 150,
    height: 3,
    rx: 1.5,
    fill: "#9A9488",
    opacity: 0.55
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 126,
    width: 168,
    height: 14,
    rx: 1.5,
    fill: "#E8E8E8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 131,
    width: 52,
    height: 4,
    rx: 2,
    fill: "#1B2B47",
    opacity: 0.65
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 150,
    width: 130,
    height: 4,
    rx: 2,
    fill: "#2D2D2D",
    opacity: 0.55
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 161,
    width: 155,
    height: 2.5,
    rx: 1.25,
    fill: "#9A9488",
    opacity: 0.4
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 170,
    width: 145,
    height: 2.5,
    rx: 1.25,
    fill: "#9A9488",
    opacity: 0.4
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 179,
    width: 135,
    height: 2.5,
    rx: 1.25,
    fill: "#9A9488",
    opacity: 0.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 188,
    width: 148,
    height: 2.5,
    rx: 1.25,
    fill: "#9A9488",
    opacity: 0.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 206,
    width: 168,
    height: 14,
    rx: 1.5,
    fill: "#E8E8E8"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 211,
    width: 44,
    height: 4,
    rx: 2,
    fill: "#1B2B47",
    opacity: 0.65
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 230,
    width: 120,
    height: 4,
    rx: 2,
    fill: "#2D2D2D",
    opacity: 0.55
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 241,
    width: 140,
    height: 2.5,
    rx: 1.25,
    fill: "#9A9488",
    opacity: 0.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 250,
    width: 100,
    height: 2.5,
    rx: 1.25,
    fill: "#9A9488",
    opacity: 0.4
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 268,
    width: 168,
    height: 14,
    rx: 1.5,
    fill: "#E8E8E8"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 273,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#1B2B47",
    opacity: 0.65
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 292,
    width: 36,
    height: 10,
    rx: 5,
    fill: "none",
    stroke: "#1B2B47",
    strokeWidth: 1,
    opacity: 0.4
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 292,
    width: 44,
    height: 10,
    rx: 5,
    fill: "none",
    stroke: "#1B2B47",
    strokeWidth: 1,
    opacity: 0.4
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 292,
    width: 40,
    height: 10,
    rx: 5,
    fill: "none",
    stroke: "#1B2B47",
    strokeWidth: 1,
    opacity: 0.4
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 308,
    width: 50,
    height: 10,
    rx: 5,
    fill: "none",
    stroke: "#1B2B47",
    strokeWidth: 1,
    opacity: 0.4
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 308,
    width: 38,
    height: 10,
    rx: 5,
    fill: "none",
    stroke: "#1B2B47",
    strokeWidth: 1,
    opacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(330, 296) rotate(-45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -60,
    width: 12,
    height: 64,
    rx: 2,
    fill: "#1B2B47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -60,
    width: 12,
    height: 16,
    rx: 2,
    fill: "#A85432"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-6,4 6,4 0,14",
    fill: "#1B2B47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: -6,
    width: 8,
    height: 3,
    rx: 1,
    fill: "#FDFCF9",
    opacity: 0.4
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 384,
    r: 4,
    fill: "#1B2B47",
    opacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 368,
    r: 2.5,
    fill: "#A85432",
    opacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 400,
    r: 3,
    fill: "#1B2B47",
    opacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6edb4b796fb1029a25838c6a2b4c5e2f.svg";
export { ForwardRef as ReactComponent };